var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgChatCheckFill = function SvgChatCheckFill(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M7.51 18.3 3.5 21.45V4.8a.9.9 0 0 1 .9-.9h16.2a.9.9 0 0 1 .9.9v12.6a.9.9 0 0 1-.9.9zm4.354-6.19L9.636 9.881l-1.272 1.273 3.5 3.5 5.091-5.09-1.273-1.274-3.818 3.818Z"
  })));
};
export default SvgChatCheckFill;